module.exports = __webpack_public_path__ + "img/_empty_states_add_contact.68e493b9.svg";